export const STAFF_LOGIN_PATH = '/backstage-sync';
export const STAFF_RESET_PATH = `${STAFF_LOGIN_PATH}/reset-password`;
export const PUBLIC_AUTH_CALLBACK_PATH = '/auth/callback';

export const DEFAULT_BACKSTAGE_QA_EMAILS = Object.freeze([
  'gameplaysync@gmail.com',
  'qa-admin@gameplaysync.dev',
]);

export const DEFAULT_PRIVILEGED_ROLES = Object.freeze(['admin']);

const normalizeStringList = (value) =>
  (Array.isArray(value) ? value : [])
    .map((entry) => (typeof entry === 'string' ? entry.trim().toLowerCase() : ''))
    .filter(Boolean);

export const isPublicationPrivilegedUser = (
  user,
  {
    allowedRoles = DEFAULT_PRIVILEGED_ROLES,
    qaEmails = DEFAULT_BACKSTAGE_QA_EMAILS,
  } = {},
) => {
  const normalizedRoles = normalizeStringList(allowedRoles);
  const normalizedQaEmails = normalizeStringList(qaEmails);
  const rawRole = user?.role || user?.app_metadata?.role;
  const role = typeof rawRole === 'string' ? rawRole.trim().toLowerCase() : null;
  const email =
    typeof user?.email === 'string' ? user.email.trim().toLowerCase() : null;

  return Boolean(
    (role && normalizedRoles.includes(role)) ||
      (email && normalizedQaEmails.includes(email)),
  );
};
